import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
      
        <div className="developers">
              <h1>Contact Developers</h1>
          <div className="developer">
            <p><strong>Mohamed Rasem Hammami</strong></p>
            <a href="mailto:mohamedrassem.hammami1@gmail.com">
              mohamedrassem.hammami1@gmail.com
            </a>
          </div>
          <div className="developer">
            <p><strong>Othman Gueddana</strong></p>
            <a href="mailto:othmangueddana@gmail.com">
              othmangueddana@gmail.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
